import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { CardContent as CardContentOriginal } from '../Card/Card';

export const ProductName = styled.span`
  ${fontTitle(14)};
`;

export const Message = styled.span`
  ${fontBody(14)};
  flex: 1;
  padding-right: 24px;
`;

export const CardContent = styled(CardContentOriginal)`
  display: flex;
`;
